import styled from 'styled-components';
import Dialog from '@mui/material/Dialog';

import colours from 'theme/atoms/colours';
import breakpoints from 'theme/atoms/breakpoints';

export const Container = styled(Dialog)`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;

  .MuiBackdrop-root {
    background-color: ${colours.neutral[900]};
    opacity: 0.5;
  }
`;

export const Card = styled('div')`
  background-color: ${colours.shade[0]};
  border-radius: 40px;
  box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.03),
    0px 0px 100px -10px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  max-width: 480px;
  overflow: hidden;
  width: 100%;
`;

export const Header = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 40px 20px 30px 20px;
  text-align: center;
`;

export const Title = styled('p')`
  color: ${colours.neutral[900]};
  font-family: 'Inter', sans-serif;
  font-size: 24px;
  font-weight: 650;
  letter-spacing: -0.48px;
  line-height: 28px;
  margin: 0;
  width: 100%;
`;

export const Body = styled('p')`
  color: ${colours.neutral[500]};
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  margin: 0;
  width: 100%;
`;

export const Actions = styled('div')`
  box-sizing: border-box;
  display: flex;
  gap: 10px;
  padding: 15px;
  width: 100%;

  & > button {
    flex: 1 1 0;
    min-width: 0;
    width: auto;
  }

  @media (max-width: ${breakpoints.mobileL}) {
    flex-direction: column;

    & > button {
      width: 100%;
    }
  }
`;
